import React from "react";

export default function Spacer({ children, ...props }) {
  return (
    <div style={{ height: props.height, width: props.width }}>{children}</div>
  );
}
